import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="timezone-field"
export default class extends Controller {
  connect() {
    this.element.value = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
